import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean, dropTipoEndereco } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';
import VirtualDrop from 'components/VirtualDrop';
import InputMask from 'components/InputMask';

const Filter = ({ grid, control, drops, filial, local, endereco }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2} alignItems="center">
      {checkDisplay('filial') && (
        <Grid item xs={12}>
          <Dropdown
            name="filial"
            control={control}
            label="Filial"
            options={drops?.Filial}
            multiple
            disabled={Boolean(filial)}
          />
        </Grid>
      )}
      {checkDisplay('local') && (
        <Grid item xs={12}>
          <Dropdown
            name="local"
            control={control}
            label="Local"
            options={drops?.LocalEstoque}
            multiple
            disabled={Boolean(local)}
          />
        </Grid>
      )}
      {checkDisplay('endereco') && (
        <Grid item xs={12}>
          <Input
            name="endereco"
            control={control}
            label="Endereço"
            disabled={Boolean(endereco)}
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <VirtualDrop
            name="produto"
            control={control}
            label="Produto"
            options={drops?.Produto}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <Input name="referencia" control={control} label="Referência" />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <Dropdown
            name="variacao"
            control={control}
            label="Variação"
            options={drops?.ProdutoVariacao}
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <Input
            name="rastreabilidade"
            control={control}
            label="Rastreabilidade"
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={6}>
          <InputMask
            name="validade.i"
            control={control}
            label="Validade (Início)"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={6}>
          <InputMask
            name="validade.f"
            control={control}
            label="Validade (Fim)"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <VirtualDrop
            name="entidade"
            control={control}
            label="Proprietário"
            options={drops?.Entidade}
            multiple
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
